/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Planning_Api_Errors_Opmerking_OngeldigInputs */

const nl_planning_api_errors_opmerking_ongeldig = /** @type {(inputs: Planning_Api_Errors_Opmerking_OngeldigInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deze opmerking is te lang.`)
};

/**

* @param {Planning_Api_Errors_Opmerking_OngeldigInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const planning_api_errors_opmerking_ongeldig = /** @type {((inputs?: Planning_Api_Errors_Opmerking_OngeldigInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planning_Api_Errors_Opmerking_OngeldigInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_planning_api_errors_opmerking_ongeldig(inputs)
});
export { planning_api_errors_opmerking_ongeldig as "planning.api_errors.opmerking_ongeldig" }